import './config-window' // Keep it here to solve this issue - https://stackoverflow.com/questions/72114775/vite-global-is-not-defined
import ReactDOM from 'react-dom/client';
//
import App from './App';
import { APP_VERSION } from "./config-global";
import { initI18n } from './locales/i18n';

window.tellMeVersion = () => {
    console.log(APP_VERSION);
}
// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

// Only the active language bundle is fetched (#1100), so i18n now boots asynchronously.
// Awaiting it before the first render is what keeps the old behaviour of never showing a
// frame of untranslated UI. If the bundle fails to arrive we still render — a UI showing
// translation keys is recoverable, a blank page is not.
initI18n()
    .catch((error) => {
        console.error('i18n initialisation failed; rendering anyway', error);
    })
    .finally(() => {
        root.render(<App />);
    });
